import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { LoaderService } from '../../../../services/loader.service';
import { LernformFacettenService } from '../../../../services/facetten/instance/lernformen-facetten/lernformfacetten.service';

import { CheckboxFacetteComponent } from '../../../checkbox-facette/checkbox-facette.component';
import { FilterSelectItem } from '../../../checkbox-facette/checkbox-liste/filterSelectItem';
import { BasisFacetteComponent } from '../../basis-facette/basis-facette.component';

@Component({
  selector: 'now-wbsuche-lib-unterrichtsform-basis-facette',
  templateUrl: './unterrichtsform-basis-facette.component.html',
  imports: [BasisFacetteComponent, CommonModule, CheckboxFacetteComponent]
})
export class UnterrichtsformBasisFacetteComponent {
  facettenService = inject(LernformFacettenService);
  loaderService = inject(LoaderService);

  @Input()
  id!: string;
  @Input()
  label!: string;
  @Input()
  modalId!: string;

  public expanded$ = this.facettenService.expanded$;
  public items$ = this.facettenService.getSelectItems$();

  public updateSelectedIds(selectedItems: FilterSelectItem[]): void {
    const selectedIds = selectedItems.map((item) => item.key);
    this.facettenService.updateSelectedIds(selectedIds);
  }
}
